<template>
  <div>
    <div class="prompt mb-4">
      <div class="prompt-tip__title ml-3">
        操作说明：
      </div>
      <div class="prompt-tip__desc ml-3">
        1、在京东款号输入框中输入需要调整出货的产品，点击查询
      </div>
      <div class="prompt-tip__desc mt-1 ml-3">
        2、在查询出的出货订单中，调整实际可出货数量，如果不出货，出货数量设置为0即可
      </div>
      <div class="prompt-tip__desc mt-1 ml-3">
        3、出货数量调整完毕后，需要重新确认出货计划，系统会根据调整后的出货数量，重新生成出货通知书、提货清单、分仓贴等数据
      </div>
    </div>
    <el-row :gutter="10" class="mb-3">
      <el-col :span="10">
        <div class="d-flex">
          <el-input
            v-model="jdItemNo"
            :placeholder="$l('tips_input_jd_item_no') || '请输入京东款号查询'"
            maxlength="50"
            clearable
            size="small"
            style="width: 100%"
          ></el-input>

          <el-button
            size="small"
            class="ml-2"
            style="width: 80px;"
            type="primary"
            @click="getData"
            >{{ $l('INDEX.btn_query') || '查询' }}</el-button
          >
        </div>
      </el-col>
    </el-row>
    <div v-loading="loading" v-if="formData.jdItemNo">
      <el-form
        ref="form"
        :model="formData"
        label-width="120px"
        label-position="top"
        size="small"
        :rules="rules"
      >
        <div class="d-flex">
          <div class="imge-wrapper">
            <el-image
              :src="defaultImageUrl"
              :preview-src-list="[defaultImageUrl]"
              style="width:156px; height:156px;padding: 1px;"
            >
              <div slot="error" class="image-slot">
                <img
                  src="/image/static/img/nopic.jpg"
                  style="width:156px; height:156px"
                />
              </div>
            </el-image>
          </div>
          <div style="flex:1">
            <div class="el-descriptions">
              <div class="el-descriptions__body descriptions__body_header">
                <div
                  class="el-descriptions__table is-bordered el-descriptions--small"
                >
                  <div class="el-descriptions-row">
                    <div
                      class="el-descriptions-item__cell el-descriptions-item__label is-bordered-label bg-white"
                    >
                      <div class="sku_main">
                        <div>
                          <span>
                            {{ formData.goodsName }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <el-descriptions
              border
              size="small"
              class="bottom-desc"
              :column="12"
            >
              <el-descriptions-item
                :label="$l('form_label_hxSkuNo') || 'SKU款号'"
                :labelStyle="{ width: '140px' }"
                :contentStyle="{ width: '200px' }"
                :span="6"
              >
                {{ formData.hxSkuNo }}
              </el-descriptions-item>
              <el-descriptions-item
                :label="$l('form_label_ncNo') || 'NC编号'"
                :labelStyle="{ width: '140px' }"
                :contentStyle="{ width: '200px' }"
                :span="6"
              >
                {{ formData.ncNo }}
              </el-descriptions-item>
              <el-descriptions-item
                :label="$l('form_label_jdItemNo') || '京东款号'"
                :labelStyle="{ width: '140px' }"
                :contentStyle="{ width: '200px' }"
                :span="6"
              >
                {{ formData.jdItemNo }}
              </el-descriptions-item>
              <el-descriptions-item
                :label="$l('form_label_jdUpcNo') || 'UPC条码'"
                :labelStyle="{ width: '140px' }"
                :contentStyle="{ width: '200px' }"
                :span="6"
              >
                {{ formData.jdUpcNo }}
              </el-descriptions-item>
              <el-descriptions-item
                :label="$l('form_label_inCtnQty') || '入数'"
                :labelStyle="{ width: '140px' }"
                :contentStyle="{ width: '200px' }"
                :span="4"
              >
                {{ formData.inCtnQty }}
              </el-descriptions-item>
              <el-descriptions-item
                :label="$l('form_label_goodsColor') || '颜色'"
                :labelStyle="{ width: '140px' }"
                :contentStyle="{ width: '200px' }"
                :span="4"
              >
                {{ formData.goodsColor }}
              </el-descriptions-item>
              <el-descriptions-item
                :label="$l('form_label_goodsSize') || '尺寸'"
                :labelStyle="{ width: '140px' }"
                :contentStyle="{ width: '200px' }"
                :span="4"
              >
                {{ formData.goodsSize }}
              </el-descriptions-item>
            </el-descriptions>
          </div>
        </div>
        <div class="d-flex pt_6 mt-4">
          <div class="side-frame-success"></div>
          <div>
            <span style="font-size: 14px; color: #606266">
              {{ $l('table_plan_order_detail') || '出货计划订单明细产品' }}
            </span>
          </div>
        </div>

        <QuantityTable
          ref="quantityTable"
          class="mt-1"
          :disabled="disabled"
          :loading="loading"
          :tableData="tableData"
          @changeTable="changeTable"
        />
      </el-form>
    </div>
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="saveAndClose()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="updatePredictDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="notSave()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="updatePredict()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import QuantityTable from './quantity-table'
export default {
  mixins: [EditLoading],
  components: { QuantityTable },
  props: {
    disabled: { type: Boolean, default: false },
    hxShipmentJdCode: { type: String, default: '' },
  },
  data() {
    return {
      formData: {},
      tmpData: {},
      loading: false,
      changeTableFlag: false,
      jdItemNo: '',
      tableData: [],
      backDialogVisible: false,
      updatePredictDialogVisible: false,
      formulatDescriptionDialogVisible: false,
      rules: {
        regionCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        topOneDailyQty: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        targetRank: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        targetDailyQty: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        amzReferralRatio: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        perFbaFreight: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        perStorageFee: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        perReturnFee: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        perCost: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        avgPrice: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        saleQty: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        saleAmount: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        saleRank: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        advRatio: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        advAmount: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        inSiteFee: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        outSiteFee: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        amzReferralFee: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        fbaFreight: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        storageFee: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        returnFee: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        operateProfit: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        operateProfitRatio: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        goodsCost: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        monthProfit: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        monthProfitRatio: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        addUpProfit: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  computed: {
    defaultImageUrl() {
      const { defaultImageUrl } = this.formData
      return defaultImageUrl
        ? this.$osscdn(defaultImageUrl)
        : '/image/static/img/nopic.jpg'
    },
  },
  mounted() {},
  methods: {
    changeTable(table) {
      table.map((e) => {
        e.tailCtnQty = this.tailCtnQty(e)
        e.fclCtnQty = this.fclCtnQty(e)
        e.subCtnQty = e.tailCtnQty + e.fclCtnQty
      })
      this.changeTableFlag = true
      this.tableData = table
    },
    fclCtnQty(row) {
      const fcq = Math.floor(row.purchaseQty / row.inCtnQty)
      return fcq
    },
    tailCtnQty(row) {
      const tcq = row.purchaseQty % row.inCtnQty
      return tcq > 0 ? 1 : 0
    },
    async getData() {
      if (!this.jdItemNo) return
      this.loading = true
      const res = await this.$api
        .ecomHxShipmentJdItemNoSearchApi({
          hxShipmentJdCode: this.hxShipmentJdCode,
          jdItemNo: this.jdItemNo,
        })
        .catch(() => null)
      const data = res?.body || {}
      this.formData = { ...data }
      this.tableData = this.formData.detailList || []
      this.$emit('showButton', this.formData.jdItemNo)
      this.loading = false
      this.changeTableFlag = false
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      if (this.changeTableFlag) {
        this.backDialogVisible = true
      } else{
        this.close()
      }
    },
    close() {
      this.backDialogVisible = false
      this.changeTableFlag = false
      this.$emit('close')
      this.$emit('reset')
    },
    async save() {
      this.backDialogVisible = false
      if (this.loadingOpen()) return
      const tableData = await this.$refs.quantityTable.getTableData()
      console.log(tableData)
      const res = await this.$api
        .ecomHxShipmentUpdateQtyApi({
          quantityList: tableData,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || res.msg,
        type: 'success',
      })
      await this.getData()
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .bottom-desc {
    .el-descriptions-item__label,
    .el-descriptions-item__content {
      border-top: none !important;
      height: 38px;
    }
  }
}
.sku_main {
  font-size: 16px;
  font-weight: bold;
  color: #101010;
  height: 31px;
  line-height: 31px;
}

.bg-white {
  background-color: white !important;
}
.side-frame {
  padding: 1px 5px;
  border-left: 3px solid $color-primary;
  height: 20px;
  margin-top: 3px;
}
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.prompt {
  height: 120px;
  background-color: #fff6f7;
  border-radius: 5px 0px 0px 5px;
  border-left: 5px solid #f56c6c;
  .prompt-tip__title {
    font-size: 14px;
    font-weight: 600;
    color: #6c6c6c;
    padding: 9px 0;
  }
  .prompt-tip__desc {
    font-size: 14px;
    color: #bbbbbb;
  }
}
.imge-wrapper {
  border: 1px solid rgba(224, 227, 234, 1);
  border-right: 0px;
}
</style>
